import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Router } from "@angular/router";
import { Observable } from 'rxjs/Observable';
import { CookieService } from 'ngx-cookie-service';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { User } from '../../models/user/user-model';

@Injectable()
export class ProfileService {
  private service = "api/User"; //Controller Name

  constructor(private http: Http,
    private readonly router: Router,
    private cookieService: CookieService) { }

  getProfile() {
    return this.http.get(`${this.service}/GetProfile?token=` + this.cookieService.get('Login'), {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler)
  }

  updateProfile(userModel: User) {
    return this.http.post(`${this.service}/UpdateProfile`, userModel, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/profile/profile.service.ts